import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // baseUrl设置
    api:{
      imgUrl: '/imgs/'
    },
    // 是否微信打开
    is_wx: false,
    // beforeunload-url
    unload_url: '',
    // url参数
    search: '',
    // 已跳转的target
    is_target: '',
    //渠道id
    channelId: '10000',
    // 支付渠道（1-微信内部 2-外部浏览器）
    source: 1,
    // routerview-key
    key:'',
    // 用户信息
    userInfo:'',
    // 用户Id
    userId:'',
    // 用户openid
    openid:'',
    //token
    token: '',
    // 导航栏title
    title:'官网',
    //导航栏返回
    leftArrow: false,
    // 当前goodsId
    goodsId: '',
    //当前浏览商品信息
    curGoods: '',
    //当前用户地址列表
    address:'',
    // 当前选择收货地址
    curAddress:'',
    //编辑收货地址
    editAddress:'',
    // 编辑订单收货地址(订单号)
    editOrderAddress: '',
    //当前操作订单
    curOrder: '',
    //首页跳转需要登录的地址名单
    loginPath: ['orderDetail', 'user_report_detailed','orderDetailTwo']
  },
  mutations: {
    //获取token、userInfo
    getUserInfo(state, data){
      console.log('getUserInfo',data)
      if(!state.token || !state.userInfo || (data && data.must)){
        state.token = localStorage.getItem('token')
        try {
          state.userInfo = JSON.parse(localStorage.getItem('userInfo')) || '';
        } catch (error) {
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          state.userInfo = '';
          state.token = '';
        }
        
      } 
      if(!state.openid || (data && data.must)){
        state.openid = localStorage.getItem('openid');
      }
    },
    //统一修改state
    comment(state,data){
      state[data.name] = data[data.name];
    },
    //同时修改多个state
    eachComment(state, data){
      data.data.forEach(item => {
        state[item.name] = item[item.name];
      });
    },

  },
  actions: {
    // dele订单
    deleOrder(context, data){
      
    },
    
  }
})
